// Textos e formatação das telas de conexões.
import type { ConnectionDto } from '@impulso/shared/api/connections'

export function timeAgo(iso: string | null): string {
  if (!iso) return 'ainda não sincronizado'
  const diff = Math.max(0, Date.now() - Date.parse(iso))
  const min = Math.round(diff / 60_000)
  if (min < 1) return 'agora mesmo'
  if (min < 60) return `há ${min} min`
  const h = Math.round(min / 60)
  if (h < 24) return `há ${h} h`
  const d = Math.round(h / 24)
  return d === 1 ? 'há 1 dia' : `há ${d} dias`
}

export function statusBadge(c: ConnectionDto): { cls: string; text: string } {
  if (c.status === 'needs_reconnect') return { cls: 'red', text: 'Precisa reconectar' }
  if (c.importing) return { cls: 'blue', text: 'Importando histórico' }
  if (c.healthLevel === 'bad') return { cls: 'red', text: 'Com problema' }
  if (c.healthLevel === 'attention') return { cls: 'amber', text: 'Precisa de atenção' }
  return { cls: 'green', text: 'Conectado' }
}

export const brand = (provider: string) => (['google_ads', 'meta', 'tiktok', 'openai_ads'].includes(provider) ? provider : 'fake')
